import React from "react";
import SourceField from "./SourceField"

function Sources({sourceList}){
	return(<cite>
				<h2>Sources</h2>
				<ul className="nonum">
				{sourceList.sourceList.map( (source) => (
					<SourceField source={source} />
				))
				}
				</ul>
			</cite>
		)
}
export default Sources;